/*
    Copyright 2022 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

import { DetectedResourceAttributes, resourceFromAttributes } from "@opentelemetry/resources";
import { NodeTracerProvider } from "@opentelemetry/sdk-trace-node";

import { DtSampler, DtSpanExporter, DtSpanProcessor, DtTextMapPropagator } from "../";

export function configureDynatrace(resourceAttributes: DetectedResourceAttributes = {}): NodeTracerProvider {
	const exporter = new DtSpanExporter();
	const processor = new DtSpanProcessor(exporter);
	const provider = new NodeTracerProvider({
		resource: resourceFromAttributes(resourceAttributes),
		sampler: new DtSampler(),
		spanProcessors: [processor]
	});

	provider.register({
		propagator: new DtTextMapPropagator()
	});

	return provider;
}
